import { render } from "./AddAccount.vue?vue&type=template&id=c06fb428&scoped=true"
import script from "./AddAccount.vue?vue&type=script&lang=js"
export * from "./AddAccount.vue?vue&type=script&lang=js"

import "./AddAccount.vue?vue&type=style&index=0&id=c06fb428&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06fb428"]])

export default __exports__